import { PersonaGroup } from '@/modules/group/modules/groups/domain/models/PersonaGroup'

import { axios, Response } from '..'

const getGroupsByCategory = async (groupCategory: string) => {
  const response: Response<PersonaGroup[]> = await axios.get(
    `/v1/groups/categories/${groupCategory}`
  )

  response[0].data = response[0].data.getAGroupByIdResponses

  return response
}

export default getGroupsByCategory
